import { CommonModule } from "@angular/common";
import { Component, computed, input } from "@angular/core";
import { Icon } from "../../icon/icon.component";

@Component({
    selector: "app-text-field",
    template: `
        <div class="flex flex-col gap-3">
            <div class="flex gap-2 items-center">
                @if (_icon(); as icon) {
                    <div class="size-6 flex items-center justify-center rounded-full bg-gray-100">
                        <app-icon size="xs" [name]="icon" class="text-gray-500" />
                    </div>
                }
                <p class="font-normal theme-text text-gray-500">
                    {{ label() }}
                </p>
            </div>
            <p class="break-all font-medium text-gray-800">
                <ng-content />
            </p>
        </div>
    `,
    imports: [CommonModule, Icon],
})
export class ArticleTextField {
    label = input.required<string>();
    icon = input<string | "date" | "document" | "price" | "location" | "address" | "contact" | "image" | "link">();

    _icon = computed(() => {
        const icon = this.icon();

        if (!icon) {
            return null;
        }

        if (icon === "link") {
            return "material-symbols:link";
        }

        if (icon === "date") {
            return "material-symbols:calendar-month";
        }

        if (icon === "document") {
            return "material-symbols:description";
        }

        if (icon === "price") {
            return "material-symbols:attach-money";
        }

        if (icon === "location") {
            return "material-symbols:location-on";
        }

        if (icon === "address") {
            return "material-symbols:home";
        }

        if (icon === "contact") {
            return "material-symbols:call-sharp";
        }

        if (icon === "image") {
            return "material-symbols:photo-library-outline-rounded";
        }

        return icon;
    });
}
